// extracted by mini-css-extract-plugin
export default {"textarea":"TextArea_textarea__rDIGM","textarea--error":"TextArea_textarea--error__ivom0"};